/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'us-east-1',
    aws_appsync_graphqlEndpoint:
        'https://yjqeqtrb6fdn5hzrm3uoiqmeki.appsync-api.us-east-1.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'API_KEY',
    aws_appsync_apiKey: 'da2-rvh6rfcvlze5hjxi7i6skfuhiu',
    aws_cognito_identity_pool_id:
        'us-east-1:f6778bff-4935-4143-95ed-e32283bd4ab1',
    aws_cognito_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_WOldxFO7M',
    aws_user_pools_web_client_id: '3rnq6rq1s0j5svhnghas8ot5ju',
    oauth: {},
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: []
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_content_delivery_bucket: 'source-data-hosting-bf-prodsage',
    aws_content_delivery_bucket_region: 'us-east-1',
    aws_content_delivery_url: 'https://d28d00o8iou6sk.cloudfront.net',
    aws_user_files_s3_bucket: 'source-data-docs-bf-prodsage',
    aws_user_files_s3_bucket_region: 'us-east-1'
};

export default awsmobile;
